import { BaseAPI } from "../../BaseAPI";
import * as environment from '../../../config/environment';

class AnketKonuListeAPI extends BaseAPI {
  

  constructor () {
    const baseUrl = environment.API_URL + "AnketKonuListe";
    super(baseUrl);
  }


  getAnketKonuListe(){

    return this.get();
  }

}
export default new AnketKonuListeAPI();
